import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { ASC } from '../internal/constants';
import { getPageRows, validateSortKey } from '../internal/helpers';

// sort all rows based on sort key and order
var getSortedRows = function getSortedRows(head, rows, sortKey, sortOrder) {
  if (!sortKey || !head) {
    return rows;
  }

  if (!rows) {
    return [];
  } // return value which will be used for sorting


  var getSortingCellValue = function getSortingCellValue(cells) {
    for (var i = 0; i < cells.length; i++) {
      if (head.cells[i] && head.cells[i].key === sortKey) {
        return cells[i].key;
      }
    }

    return undefined;
  }; // Get copy of rows to avoid sorting prop in place


  var sortableRows = Array.from(rows); // Reorder rows in table based on sorting cell value
  // Algorithm will sort numerics or strings, but not both

  return sortableRows.sort(function (a, b) {
    var valA = getSortingCellValue(a.cells);
    var valB = getSortingCellValue(b.cells); // modifier used for sorting type (ascending or descending)

    var modifier = sortOrder === ASC ? 1 : -1;

    if (valA === undefined || valB === undefined) {
      return modifier;
    }

    if (_typeof(valA) !== _typeof(valB)) {
      // numbers are always grouped higher in the sort
      if (typeof valA === 'number') {
        return -1;
      }

      if (typeof valB === 'number') {
        return 1;
      } // strings are grouped next


      if (typeof valA === 'string') {
        return -1;
      }

      if (typeof valB === 'string') {
        return 1;
      }
    } // Sort strings using localeCompare


    if (typeof valA === 'string' && typeof valB === 'string') {
      return modifier * valA.localeCompare(valB, undefined, {
        sensitivity: 'accent',
        numeric: true
      });
    }

    if (!valA && valA !== 0 || valA < valB) {
      return -modifier;
    }

    if (!valB && valB !== 0 || valA > valB) {
      return modifier;
    }

    if (valA === valB) {
      return 0;
    }

    return 1;
  });
};

// get one page of data in table, sorting all rows previously
export default function withSortedPageRows(WrappedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(WithSortedPageRows, _React$Component);

    var _super = _createSuper(WithSortedPageRows);

    function WithSortedPageRows() {
      var _this;

      _classCallCheck(this, WithSortedPageRows);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "state", {
        pageRows: []
      });

      return _this;
    }

    _createClass(WithSortedPageRows, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(_prevProps, prevState) {
        if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) {
          this.props.onPageRowsUpdate(this.state.pageRows);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            rows = _this$props.rows,
            head = _this$props.head,
            sortKey = _this$props.sortKey,
            sortOrder = _this$props.sortOrder,
            rowsPerPage = _this$props.rowsPerPage,
            page = _this$props.page,
            restProps = _objectWithoutProperties(_this$props, ["rows", "head", "sortKey", "sortOrder", "rowsPerPage", "page"]);

        return /*#__PURE__*/React.createElement(WrappedComponent //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
        , _extends({
          pageRows: this.state.pageRows,
          head: head
        }, restProps));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(props, state) {
        var rows = props.rows,
            head = props.head,
            sortKey = props.sortKey,
            sortOrder = props.sortOrder,
            page = props.page,
            rowsPerPage = props.rowsPerPage,
            isTotalPagesControlledExternally = props.isTotalPagesControlledExternally;
        validateSortKey(sortKey, head);
        var sortedRows;
        var pageRows;

        if (isTotalPagesControlledExternally) {
          sortedRows = rows;
          pageRows = rows;
        } else {
          sortedRows = getSortedRows(head, rows, sortKey, sortOrder) || [];
          pageRows = getPageRows(sortedRows, page, rowsPerPage);
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          pageRows: pageRows
        });
      }
    }]);

    return WithSortedPageRows;
  }(React.Component);
}